module.exports = __webpack_public_path__ + "static/media/viking-ship.e20cfd57.png";